import { faPencil, faTrash } from '@fortawesome/pro-light-svg-icons';
import type { ColDef } from 'ag-grid-enterprise';

import PERMISSIONS from '@/constants/auth.constants';
import { BOOL_LABELS } from '@/constants/common';
import type { Organization } from '@/pages/Organizations/Organizations.types';
import { checkMarkRenderer } from '@/utils/GridRenderer.utils';

import {
  OrgActionCellRenderer,
  OrgCountCellRenderer,
  OrgExpandCellRenderer,
  OrgNameCellRenderer,
  OrgProductStatusCellRenderer,
  OrgProductTypeCellRenderer
} from './OrganizationsTable.cellRenderers';

export const defaultColDef: ColDef = { sortable: true };

export const COLUMN_DEFS: ColDef<Organization>[] = [
  {
    headerName: '',
    width: 50,
    sortable: false,
    suppressHeaderMenuButton: true,
    resizable: false,
    cellRenderer: OrgExpandCellRenderer
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 2,
    cellRenderer: OrgNameCellRenderer
  },
  { field: 'label', headerName: 'Label', width: 200 },
  { field: 'uci', headerName: 'UCI', flex: 1 },
  {
    field: 'product_type',
    headerName: 'Product Types',
    minWidth: 250,
    flex: 1,
    sortable: false,
    cellRenderer: OrgProductTypeCellRenderer
  },
  {
    field: 'active_products',
    headerName: 'Active Products',
    width: 160,
    cellRenderer: OrgCountCellRenderer
  },
  {
    field: 'ai_enabled',
    headerName: 'AI Enabled',
    width: 130,
    valueGetter: (params) => params.data?.ai_enabled === BOOL_LABELS.ENABLED,
    cellRenderer: checkMarkRenderer
  },
  {
    field: 'product_status',
    headerName: 'Warnings',
    flex: 1,
    cellRenderer: OrgProductStatusCellRenderer
  },
  {
    field: 'total_users',
    headerName: 'Total Users',
    width: 150,
    cellRenderer: OrgCountCellRenderer
  },
  { field: 'type', headerName: 'Type', width: 130 },
  {
    headerName: '',
    width: 50,
    sortable: false,
    suppressHeaderMenuButton: true,
    resizable: false,
    cellStyle: { paddingLeft: 0 },
    cellRenderer: OrgActionCellRenderer
  }
];

export const PRODUCTS_CONTEXT_MENU_ITEMS = [
  {
    label: 'Edit',
    icon: faPencil,
    permission: PERMISSIONS.ORGANIZATIONS_UPDATE
  },
  {
    label: 'Delete',
    icon: faTrash,
    permission: PERMISSIONS.ORGANIZATIONS_UPDATE
  }
];
